import React from "react";
import { Menu, Search, Sparkles, Moon, Sun, Crown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";
import { useUI } from "@/context/UIContext";
import { useTheme } from "@/context/ThemeContext";
import { useAuth } from "@/context/AuthContext";

export function Topbar({ onMenu, search, setSearch, title }) {
  const { openAnalyze } = useUI();
  const { theme, toggleTheme } = useTheme();
  const { user } = useAuth();
  const isPremium = user?.plan === "pro" || user?.plan === "plus";

  return (
    <header className="sticky top-0 z-30 flex h-16 items-center gap-3 border-b border-border bg-background/80 backdrop-blur-md px-4 lg:px-6">
      <button
        onClick={onMenu}
        className="lg:hidden p-2 -ml-2 rounded-md hover:bg-secondary"
        data-testid="mobile-menu-btn"
      >
        <Menu className="h-5 w-5" />
      </button>

      <h1 className="font-display text-base font-semibold tracking-tight hidden sm:block">{title}</h1>

      <div className="flex-1 max-w-md ml-auto lg:ml-6">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
          <Input
            value={search}
            onChange={(e) => setSearch?.(e.target.value)}
            placeholder="Search analyzed videos, channels, IDs..."
            className="pl-9 h-9 bg-secondary/50 border-transparent focus-visible:border-border"
            data-testid="topbar-search"
          />
        </div>
      </div>

      <button
        onClick={toggleTheme}
        className="p-2 rounded-md hover:bg-secondary text-muted-foreground hover:text-foreground"
        data-testid="theme-toggle-topbar"
        title="Toggle theme"
      >
        {theme === "dark" ? <Sun className="h-4.5 w-4.5" /> : <Moon className="h-4 w-4" />}
      </button>

      {isPremium && (
        <Badge className="hidden sm:flex gap-1 border-0 bg-amber-500/15 text-amber-500">
          <Crown className="h-3 w-3" /> {user?.plan === "plus" ? "Plus" : "Pro"}
        </Badge>
      )}

      <Button onClick={openAnalyze} className="gap-2 h-9 ring-accent relative" data-testid="topbar-analyze-btn">
        <Sparkles className="h-4 w-4" />
        <span className="hidden sm:inline">Analyze Video</span>
      </Button>
    </header>
  );
}
